import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { PageContainer } from "@fleet/ui";
import { Hammer } from "@fleet/icons";
import { useI18n } from "@/providers/i18n-provider";

function ModalSandboxPage() {
  const { t } = useI18n();
  return (
    <div class="flex flex-1 flex-col min-h-0 overflow-hidden bg-background">
      <PageContainer maxWidth="4xl" class="space-y-8" containerClass="min-h-0">
        <div>
          <h1 class="text-3xl font-extrabold tracking-tight flex items-center gap-2">
            <Hammer class="h-8 w-8 text-primary" />
            {t(msg`Modal Sandbox`)}
          </h1>
          <p class="text-sm text-muted-foreground mt-2">
            {t(
              msg`The modal sandbox has been deprecated following the Chronos Sync cutoff consolidation.`,
            )}
          </p>
        </div>
      </PageContainer>
    </div>
  );
}

export const sandboxModalRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/modal",
  component: ModalSandboxPage,
});
